import request from '@/utils/request'

export function createArticle(data) {
  return request({
    url: '/article/add',
    method: 'post',
    headers: { 'oper': '添加文章', 'oper-type': 1001 },
    data
  })
}
export function upArticle(data) {
  return request({
    url: '/article/update',
    method: 'post',
    headers: { 'oper': '文章修改', 'oper-type': 1002 },
    data
  })
}
export function fetchArticle(data) {
  return request({
    url: '/article/detail',
    method: 'post',
    headers: { 'oper': '查询文章详情', 'oper-type': 1003 },
    data
  })
}
export function listAndFile(data) {
  return request({
    url: '/article/listAndFile-page',
    method: 'post',
    headers: { 'oper': '获取带文件列表', 'oper-type': 1004 },
    data
  })
}

export function fetchList(query) {
  return request({
    url: '/article/list',
    method: 'post',
	headers: { 'oper': '文章列表', 'oper-type': 1005 },
    params: query
  })
}

